import { render } from "./FormMultiversity.vue?vue&type=template&id=b4c3fcbc&scoped=true"
import script from "./FormMultiversity.vue?vue&type=script&lang=js"
export * from "./FormMultiversity.vue?vue&type=script&lang=js"

import "./FormMultiversity.vue?vue&type=style&index=0&id=b4c3fcbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c3fcbc"]])

export default __exports__